import { Button } from "@/components/ui/button";
import { useStore } from "@/store";
import { t } from "i18next";
import { ArrowUpDown, Pencil, Trash } from "lucide-react";
import { toast } from "sonner";
import { DataTableRowActions } from "../data-table-row-actions.jsx";

const handleDelete = (id) => {
  const deleteUser = useStore.getState().deleteUser;
  deleteUser(id);
  toast.success(t("alertDialog.toast.userDeletedSuccess"));
};

const handleUpdate = async (id) => {
  const getUserToUpdateData = useStore.getState().getUserToUpdateData;
  const setUpdateModal = useStore.getState().setUpdateModal;
  try {
    await getUserToUpdateData(id);
    setUpdateModal(true);
  } catch (error) {
    console.error("Error al cargar el usuario.", error);
  }
};

export const columns = [
  {
    accessorKey: "user",
    header: ({ column }) => {
      return (
        <Button
          className="uppercase text-xs"
          variant="ghost"
          onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
        >
          {t("headColumns.users.user")}
          <ArrowUpDown className="ml-2 h-4 w-4" />
        </Button>
      );
    },
    cell: ({ row }) => <div className="ml-4">{row.getValue("user")}</div>,
  },
  {
    accessorKey: "username",
    header: ({ column }) => {
      return (
        <Button
          className="uppercase text-xs"
          variant="ghost"
          onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
        >
          {t("headColumns.users.userName")}
          <ArrowUpDown className="ml-2 h-4 w-4" />
        </Button>
      );
    },
    cell: ({ row }) => <div className="ml-4">{row.getValue("username")}</div>,
  },
  {
    accessorKey: "rol",
    header: ({ column }) => {
      return (
        <Button
          className="uppercase text-xs"
          variant="ghost"
          onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
        >
          {t("headColumns.users.roles")}
          <ArrowUpDown className="ml-2 h-4 w-4" />
        </Button>
      );
    },
    cell: ({ row }) => <div className="ml-4">{row.getValue("rol")}</div>,
  },
  {
    accessorKey: "active",
    header: ({ column }) => {
      return (
        <Button
          className="uppercase text-xs"
          variant="ghost"
          onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
        >
          {t("headColumns.users.active")}
          <ArrowUpDown className="ml-2 h-4 w-4" />
        </Button>
      );
    },
    cell: ({ row }) => <div className="ml-4">{row.getValue("active")}</div>,
  },
  {
    id: "actions",
    cell: ({ row }) => (
      <DataTableRowActions
        row={row}
        actions={[
          {
            label: t("buttonTexts.delete"),
            onClick: (row) => handleDelete(row.original.id),
            icon: Trash,
          },
          {
            label: t("buttonTexts.edit"),
            onClick: (row) => handleUpdate(row.original.id),
            icon: Pencil,
          },
        ]}
      />
    ),
  },
];
